<template>
  <div>
    <van-pull-refresh v-model="loadingFresh" @refresh="onRefresh">
      <van-list
          v-model="loadingMore"
          :finished="noMore"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-cell v-for="item in list" :key="item.id">
            <span slot="default">
                <p>
                    <span>{{item.title}}</span>
                    <span class="list-right" v-if="item.change>0">+{{item.change}}</span>
                    <span class="list-right" v-else>{{item.change}}</span>
                </p>
               <div style="color: #969799;">{{item.create_time_str}} 当前积分 {{item.score}}</div>
            </span>
        </van-cell>

      </van-list>
    </van-pull-refresh>


    <div class="add-btn">
      <div class="add-b-b">
        <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round  @click="submit">申请额外积分</van-button>
          
      </div>
    </div> 
  </div>
</template>
<style scoped>
.add-btn {
  position: fixed;
  width: 100%;
  height: 1.3rem;
  bottom: 0.4rem;
}
.add-b-b {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-list >>> p {
  font-size: 16px;
  font-weight: 700;
}

.list-right {
  float: right;
}
</style>

<script>
import Vue from "vue";
import {List, PullRefresh} from "vant";

Vue.use(PullRefresh).use(List);

export default {
  name: 'ClubDetailScore',
  data() {
    return {
      loadingFresh: false,
      loadingMore: false,
      noMore: false,
      params: {
        id:0,
        p: 1,
        step: 10,
      },
      list: []
    };
  },
  mounted() {
    document.title = '积分明细'
    this.params.id = this.$route.query.id
    this.getList()
  },

  methods: {    
    submit(){
      rbLink({
        name:"ClubScoreApplyList",
        query:{
          id:this.params.id
        }
      })
    },
    getList() {
      let that = this;
      that.$api.get('/api/club/scoreList', that.params, res => {
        that.loadingMore = false;

        if (res.data.currentpage == 1) {
          that.list = res.data.list
          that.loadingFresh = false

        } else {
          let list = res.data.list

          list.map(item => {
            that.list.push(item)
          })
        }
        if (res.data.list.length == 0) {
          that.noMore = true;
        }

        this.params.p += 1;

      });
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      if (this.params.p > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.p = 1;
      that.getList();
    },
  }
};
</script>



// WEBPACK FOOTER //
// ClubDetailScore.vue?7bd1e106